import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';

import RefundRequestList from './submodules/list';

const RefundRequest: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.refundRequest}
				configActionName={ACTION.getTournamentRefundRequestInBulk}
				path={`${path}/list`}
				component={RefundRequestList}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default RefundRequest;
